/**
 * @generated SignedSource<<0c44be59a9accd3af4eee1ea145ec9c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CheckInStatus = "CHECKED_IN" | "NONE" | "NO_SHOW";
export type EventRegistrationType = "CUSTOMER" | "GUEST" | "MEMBER";
export type FormQuestionType = "BOOLEAN" | "CHECKBOXES" | "EMAIL" | "GHIN_NUMBER" | "LONG_TEXT" | "MULTIPLE_CHOICE" | "NAME" | "PHONE_NUMBER" | "TEXT" | "TOGGLE" | "TRANSPORTATION";
import { FragmentRefs } from "relay-runtime";
export type EventDetailAttendeesListItemFragment$data = {
  readonly checkedIn: CheckInStatus;
  readonly id: string;
  readonly registrations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly formResponses: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly booleanValue: boolean | null | undefined;
              readonly id: string;
              readonly questionConfiguration: {
                readonly enabled: boolean;
                readonly id: string;
                readonly type: FormQuestionType;
              };
              readonly stringValue: string | null | undefined;
              readonly transportationType: {
                readonly id: string;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly index: number | null | undefined;
        readonly registrant: {
          readonly firstName: string | null | undefined;
          readonly id: string;
          readonly lastName: string | null | undefined;
          readonly profileImage: {
            readonly publicId: string;
          } | null | undefined;
        } | null | undefined;
        readonly type: EventRegistrationType | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly waitlistIndex: number | null | undefined;
  readonly " $fragmentType": "EventDetailAttendeesListItemFragment";
};
export type EventDetailAttendeesListItemFragment$key = {
  readonly " $data"?: EventDetailAttendeesListItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailAttendeesListItemFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailAttendeesListItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "waitlistIndex",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkedIn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventRegistrationConnection",
      "kind": "LinkedField",
      "name": "registrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventRegistrationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "index",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "registrant",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Image",
                      "kind": "LinkedField",
                      "name": "profileImage",
                      "plural": false,
                      "selections": [
                        {
                          "alias": "publicId",
                          "args": null,
                          "kind": "ScalarField",
                          "name": "renderingKey",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventFormResponseConnection",
                  "kind": "LinkedField",
                  "name": "formResponses",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EventFormResponseEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "EventFormResponse",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "booleanValue",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "stringValue",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TransportationType",
                              "kind": "LinkedField",
                              "name": "transportationType",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/)
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FormQuestionConfiguration",
                              "kind": "LinkedField",
                              "name": "questionConfiguration",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "enabled",
                                  "storageKey": null
                                },
                                (v0/*: any*/),
                                (v1/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventSignUp",
  "abstractKey": null
};
})();

(node as any).hash = "1c3a80bd5a9cb7151650285c732ff714";

export default node;
